import React from "react";

export const init = {
  session: {
    state: { user: undefined, isLoggedIn: false, loading: true }
  }
};

export default React.createContext(init);
